module.exports = __webpack_public_path__ + "img/logo-ii-text.71d7b82f.png";